/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import {
  Modal,
  TextInput,
  NativeSelect,
  Stack,
  Button,
  Textarea,
  Text,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import {
  useForm,
  isNotEmpty,
  isEmail,
  hasLength,
} from '@mantine/form';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useAuth } from '../Auth';
import { submitContactForm } from '../api';
import Link from './Link';

function ContactModal(){
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const isOpened = searchParams.get('contact')
  const [opened, { open, close }] = useDisclosure(isOpened);
  const location = useLocation();
  const { user } = useAuth();


  const topics = [
    { value: 'general', label: 'General inquiry' },
    { value: 'terms-privacy', label: 'Terms & privacy' },
    { value: 'request', label: 'Feature request' },
    { value: 'pricing', label: 'Pricing' },
    { value: 'bug', label: 'Bug report' },
  ];

  const resetSearchParams = () => {
    searchParams.delete('contact');
    setSearchParams(searchParams);
  };

  const form = useForm({
    initialValues: {
      name: '',
      email: '',
      topic: 'general',
      comments: '',
      path: '/',
      date: new Date().toString(),
      captchaValue: null,
    },
    validate: {
      name: isNotEmpty('Enter your name.'),
      email: isEmail('Enter a valid email address.'),
      comments: hasLength({ max: 500 }, 'Comment must be under 500 characters.'),
    },
  });

  const getDefaultFormValues = () => {
    // update date
    const date = new Date().toString();
    form.setValues({ date });

    // update path
    const path = location.pathname;
    form.setValues({ path });
    
    // update topic field
    let topic = 'general'
    if (path === '/terms' || path === '/privacy'){
      topic = 'terms-privacy';
    }
    form.setValues({ topic });

    if (user) {
      const {
        email,
        display_name,
      } = user.data;

      form.setValues({ 
        email,
        name: display_name,
      });
    }
  };

  const onSubmit = async (values) => {
  
    if (!executeRecaptcha) { return; } // captcha not loaded

    const captchaToken = await executeRecaptcha('submit_form');
    setIsLoading(true);

    submitContactForm({captchaToken, ...values})
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(() => {
        setIsLoading(false);
        form.reset();
        close();
      })
      .catch((error) => {
        console.error('Error fetching playlist:', error); // eslint-disable-line
      });
  }


  useEffect(() => {
    getDefaultFormValues();
    if (isOpened) {
      open();
      resetSearchParams();
    }
  }, [isOpened])


  return (
    <Modal
      opened={opened}
      onClose={close}
      closeButtonProps={{ size: 'md' }}
      title='Contact us'
    >
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Stack>
          <NativeSelect
            label='Topic'
            placeholder='Pick one'
            data={topics}
            withAsterisk
            {...form.getInputProps('topic')}
          />
          
          <TextInput
            label='Name'
            placeholder='Rick Astley'
            withAsterisk
            {...form.getInputProps('name')}
          />
          
          <TextInput
            label='Email'
            placeholder='rick@rickroll.com'
            withAsterisk
            {...form.getInputProps('email')}
          />

          <Textarea
            label='Additional comments'
            placeholder='Never gonna give you up'
            {...form.getInputProps('comments')}
          />

          <Button mt='xs' loading={isLoading} type='submit'>Submit</Button>
          
          <Text align='center' c='dimmed' fz='xs' lh='100%'>
            This site is protected by reCAPTCHA and the Google&nbsp;
            <Link newTab href="https://policies.google.com/privacy">privacy policy</Link> and&nbsp;
            <Link newTab href="https://policies.google.com/terms">terms of service</Link> apply.
          </Text>

        </Stack>
      </form>
    </Modal>
  )
};

export default ContactModal;